import React from 'react';
import { getRecText } from '../utils/recommendations';
import '../styles/RecommendationTip.scss';

const RecommendationTip = ({ ind, actual, pts, spendRow }) => {
  if (pts >= ind.points) return null;
  return (
    <span className="sc-rec-tip">
      <span className="sc-rec-tip__icon">ⓘ</span>
      <span className="sc-rec-tip__popup">
        <strong>How to improve</strong>
        {getRecText(ind, actual, ind.points - pts, spendRow)}
      </span>
    </span>
  );
};

export default RecommendationTip;
